<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="用户" width="25%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="unitUserInfo" ref="unitUserForm" :rules="rules" size="small">
          <el-form-item label="所属部门" :inline="true" prop="fullName">
            <el-select v-model="selectDeptId" filterable placeholder="请选择部门" style="width:100%">
              <el-option v-for="item in deptOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="姓名" :inline="true" prop="fullName">
            <el-input v-model="unitUserInfo.fullName" placeholder="请输入姓名" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户名" :inline="true" prop="userName">
            <el-input v-model="unitUserInfo.userName" :disabled="unitUserInfo.isEdit" placeholder="请输入账户名（登录使用）" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :inline="true" prop="phoneNumber">
            <el-input v-model="unitUserInfo.phoneNumber" :disabled="unitUserInfo.isEdit" placeholder="请输入手机号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" :inline="true" prop="email">
            <el-input v-model="unitUserInfo.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" :inline="true" prop="remarks">
            <el-input v-model="unitUserInfo.remarks" placeholder="请输入备注" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="saveUnitUserFunc()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { Message,MessageBox } from 'element-ui';
import { listUnitDept } from "@/api/dept";
import { saveUnitUser } from "@/api/unitUser";

export default {
  name: "UnitUserDialog",
  props: {
    dialogVisible: false,
    deptOptions: [],
    unitUserInfo : {
        id: '',
        deptId:'',
        fullName:'',
        userName:'',
        phoneNumber:'',
        email:'',
        remarks:'',
        isEdit: false,
    },
  },
  data(){
    return {
      rules: {
            fullName: [
              { required: true, message: "请输入姓名", trigger: "blur" },
            ],
            userName: [
              { required: true, message: "请输入账户名", trigger: "blur" },
            ],
            phoneNumber: [
              { required: true, message: "请输入手机号码", trigger: "blur" },
            ],
      },
      selectDeptId: null,
      loading:false,
    }
  },
  mounted(){
    
  },
  created() {
    this.selectDeptId = this.$props.unitUserInfo.deptId;
  },
  watch : {
    unitUserInfo(newObj,oldObj){
      this.selectDeptId = newObj.deptId;
    }
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },

    //保存用户信息
    saveUnitUserFunc(){
      let this_ = this;
      this.$nextTick(() => {
        this_.$refs.unitUserForm.validate((valid) => {
            if(valid){
              let param = {...this_.unitUserInfo}  
                  param.deptId = this_.selectDeptId;
              this_.loading = true;
              saveUnitUser(param).then(res => {
                  this_.loading = false;
                  if(res.code == 200){
                    Message.success('保存成功'); 
                    this_.selectDeptId = '';
                    this_.$emit('close');
                  } else {
                    Message.error(res.msg);
                  }
              });
            } 
        });
      });
    },

    //获取部门选择下拉框
    getDeptInfos(){
      listUnitDept({}).then(res => {
        this.deptOptions = res.data;
      });
    }
    
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/dialog/UnitUserDialog.vue